import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AnalyticsApi } from 'src/services/analyticsApi'
import {
  InboxAnalysisPage,
  InboxAnalysisPagesResponse,
  UseGetInboxAnalysisPagesParams,
} from './interfaces/useGetInboxAnalysisPagesQuery.interface'

export type { InboxAnalysisPage }
export type {
  InboxAnalysisPageKeyInsights,
  InboxAnalysisPageOperator,
} from './interfaces/useGetInboxAnalysisPagesQuery.interface'

const getInboxAnalysisPages = async (
  fromDate?: string,
  toDate?: string,
  tz?: string
): Promise<InboxAnalysisPagesResponse | null> => {
  const { data } = await AnalyticsApi.v1Private.inboxAnalysisPagesList(
    {
      fromDate,
      toDate,
      tz,
    },
    {
      format: 'json',
    }
  )

  return data as InboxAnalysisPagesResponse
}

export const useGetInboxAnalysisPagesQuery = (
  params: UseGetInboxAnalysisPagesParams,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    enabled: options?.enabled ?? true,
    queryFn: () =>
      getInboxAnalysisPages(params.fromDate, params.toDate, params.tz),
    queryKey: [
      QueryKey.GET_INBOX_ANALYSIS_PAGES,
      params.fromDate,
      params.toDate,
      params.tz,
    ],
  })
}
